<script lang="ts">
    export let cardprops: string = "";
    export let cardbodyprops: string = "";
    export let customCol: string = "";
    export let cardtitle: string = "";
    export let cardtitleprops: string = "";
    export let cardvalue: string = "";
    export let cardsubprops: string = "";
    export let cardsubvalue: string = "";
    export let customsubCol: string = "";
    export let sign: string = "";
    export let countervalue: string = "";
</script>

<div class="card {cardprops}">
    <div class="chart-widget-top">
        <div class="card-body {cardbodyprops}">
            <div class={customCol}>
                <h6 class={cardtitleprops}>{cardtitle}</h6>
                <span class="num"
                    ><span class="counter">{cardvalue} </span>%<i
                        class="icon-angle-up f-12"
                    />
                </span>
            </div>
            <div class={customsubCol}>
                <h4 class={cardsubprops}>
                    {#if sign || countervalue}
                        {sign}
                        <span class="counter">{countervalue}</span>
                    {/if}
                    {cardsubvalue}
                </h4>
            </div>
        </div>
        {#if $$slots.customChart}
            <slot name="customChart" />
        {/if}
    </div>
</div>
